import { ObjectDeserializer } from 'object-deserializer';
import stringOrNumberDeserializer from '../../../utils/stringOrNumberDeserializer';
import {
  Competitor,
  MatchScheme,
  RequestTournamentsList,
  RequestTourney,
  RequestTourneyScheme,
  Tournament,
  TournamentStatistics,
  Tourney,
} from './interfaces';

export function tourneyDeserializer(o: ObjectDeserializer): Tourney {
  return {
    GameID: o.required('GameID').asNumber,
    TourneyID: o.required('TourneyID').asString,
    EntryFee: o.required('EntryFee').asNumber,
    Name: o.required('Name').asString,
    MobileName: o.required('MobileName').asString,
    Description: o.required('Description').asString,
    RoomName: o.required('RoomName').asString,
    Comment: o.optional('Comment')?.asString,
    TimeControl: o.required('TimeControl').asString,
    TrnType: o.required('TrnType').asNumber,
    Rounds: o.optional('Rounds')?.asString,
    ExtraBonus: o.required('ExtraBonus').asString,
    PairingType: o.required('PairingType').asString,
    DirectorName: o.required('DirectorName').asString,
    Director: o.required('Director').asString,
    Creator: o.required('Creator').asString,
    Status: o.required('Status').asString,
    NumPrizes: o.required('NumPrizes').asNumber,
    ConsPrize: o.optional('ConsPrize')?.asString,
    Host: o.optional('Host')?.asString,
    Port: o.optional('Port')?.asNumber,
    StartTimeUTC: o.required('StartTimeUTC').asString,
    StartTime: o.required('StartTime').asString,
    FinishTimeUTC: o.optional('FinishTimeUTC')?.asString,
    FinishTime: o.optional('FinishTime')?.asString,
    FirstPrizeUsr: o.optional('FirstPrizeUsr')?.asString,
    FirstPrizeID: o.optional('FirstPrizeID')?.asString,
    FirstPrizeAmt: o.optional('FirstPrizeAmt')?.asString,
    SecondPrizeUsr: o.optional('SecondPrizeUsr')?.asString,
    SecondPrizeID: o.optional('SecondPrizeID')?.asString,
    SecondPrizeAmt: o.optional('SecondPrizeAmt')?.asString,
    ThirdPrizeUsr: o.optional('ThirdPrizeUsr')?.asString,
    ThirdPrizeID: o.optional('ThirdPrizeID')?.asString,
    ThirdPrizeAmt: o.optional('ThirdPrizeAmt')?.asString,
    FourthPrizeUsr: o.optional('FourthPrizeUsr')?.asString,
    FourthPrizeID: o.optional('FourthPrizeID')?.asString,
    FourthPrizeAmt: o.optional('FourthPrizeAmt')?.asString,
    NumPlayed: o.optional('NumPlayed')?.asNumber,
    utime: o.required('utime').asString,
    wssproxy: o.optional('wssproxy')?.asString,
  };
}

export function tournamentStatisticsDeserializer(
  o: ObjectDeserializer
): TournamentStatistics {
  return {
    tourneys: o.required('tourneys').asArrayOfObjects(tourneyStatsDeserializer),
  };
}

export function tourneyStatsDeserializer(o: ObjectDeserializer): Tournament {
  return {
    EntryFee: o.required('EntryFee').as(stringOrNumberDeserializer),
    StartTime: o.required('StartTime').asString,
    GameName: o.required('GameTitle').asString,
    TourneyID: o.required('TourneyID').as(stringOrNumberDeserializer),
    FirstPlace: o.optional('FirstPlace')?.asString,
    SecondPlace: o.optional('SecondPlace')?.asString,
    Prize: o.required('PrizeAmt').as(stringOrNumberDeserializer),
  };
}

export function requestTournamentListDeserializer(
  o: ObjectDeserializer
): RequestTournamentsList {
  return {
    code: o.required('code').asNumber,
    F: o.required('F').asArrayOfObjects(tourneyDeserializer),
    P: o.required('P').asArrayOfObjects(tourneyDeserializer),
    S: o.required('S').asArrayOfObjects(tourneyDeserializer),
  };
}

export function requestTourneyDeserializer(
  o: ObjectDeserializer
): RequestTourney {
  return {
    code: o.required('code').asNumber,
    tourney: o.required('tourney').asObject(tourneyDeserializer),
  };
}
export function competitorDeserializer(
  value: [string, number, string]
): Competitor {
  return {
    usr: value[0],
    rating: value[1],
    uid: value[2],
  };
}

export function competitorObjectDeserializer(
  o: ObjectDeserializer
): Competitor {
  return {
    usr: o.required('usr').asString,
    rating: o.required('rating').asNumber,
    uid: o.required('uid').asString,
  };
}

export function matchSchemeDeserializer(o: ObjectDeserializer): MatchScheme {
  return {
    '0': o.optional('0')?.asString,
    '1': o.optional('1')?.asString,
    L: o.optional('L')?.asString,
    W: o.optional('W')?.asString,
  };
}

export function requestTourneySchemeDeserializer(
  o: ObjectDeserializer
): RequestTourneyScheme {
  return {
    code: o.required('code').asNumber,
    COMPETITORS: o.required('COMPETITORS').asArray(competitorDeserializer),
    FINAL: o.optional('FINAL')?.asObject(matchSchemeDeserializer),
    LOSERS: o
      .optional('LOSERS')
      ?.asArray((value) =>
        value.map((match: any) =>
          matchSchemeDeserializer(new ObjectDeserializer(match))
        )
      ),
    WINNERS: o
      .required('WINNERS')
      .asArray((value) =>
        value.map((match: any) =>
          matchSchemeDeserializer(new ObjectDeserializer(match))
        )
      ),
    tourney: o.optional('tourney')?.asObject(tourneyDeserializer),
  };
}
